import { render, staticRenderFns } from "./home.vue?vue&type=template&id=1a26161a&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=1a26161a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a26161a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Workplace\\vueProject\\edu_aim\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a26161a')) {
      api.createRecord('1a26161a', component.options)
    } else {
      api.reload('1a26161a', component.options)
    }
    module.hot.accept("./home.vue?vue&type=template&id=1a26161a&scoped=true", function () {
      api.rerender('1a26161a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/hwk/home.vue"
export default component.exports